import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter
} from "react-router-dom"
import Signin from './Signin'
import VendorPage from './vendor/VendorPage'
import FunAdmin from './admin/FunAdmin'


export class PrivateRoutes extends Component {

	componentDidMount(){
		// console.log('mounted',this.props);
	}

	render() {
		let {
			state,
			updateState,
			login
		} = this.props
    console.log('state',state);

		if(state.admin){
			return (
				<FunAdmin authUser={state.authUser} />
			)
		}

		if(state.vendor){
			return (
				<VendorPage authUser={state.authUser} />
			)
		}

		return (
			<Signin
				// updateState={updateState}
			/>
		)

	}
}



export default PrivateRoutes



// WEBPACK FOOTER //
// ./src/components/PrivateRoutes.js